import { render, staticRenderFns } from "./LeadBoxContacting.vue?vue&type=template&id=38a14fa8&"
import script from "./LeadBoxContacting.vue?vue&type=script&lang=js&"
export * from "./LeadBoxContacting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports